import _ from 'lodash'
import customerApi from '@/api/customer'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const state = {
  list: [],
  totalCount: 0,
  errors: [],
  loading: false,
  filters: {
    pageNumber: 1,
    pageSize: 10,
    searchQuery: '',
    sortBy: '',
    sortDesc: false,
  },
}

const getters = {
}

const actions = {
  fetchList({ commit }) {
    state.loading = true
    customerApi.getAll({ ...state.filters })
      .then(({ data }) => commit('SET_LIST', data))
  },
  resetSmsLimit({ commit }, id) {
    return customerApi.resetSmsLimit(id)
      .then(() => commit('SMS_LIMIT_RESET'))
      .catch(error => {
        commit('SMS_LIMIT_RESET_FAILED', { message: error.response && error.response.data && error.response.data.message })
        throw error
      })
  },
}

const mutations = {
  SET_LIST(state, { items, metadata }) {
    state.list = items
    state.totalCount = metadata.totalItemCount
    state.loading = false
  },
  CLEAR_ERRORS(state) {
    state.errors = []
  },
  SMS_LIMIT_RESET() {
    store.dispatch('customer/fetchList')
    store.dispatch('message/success', 'CUSTOMER_SMS_LIMIT.reset')
  },
  SMS_LIMIT_RESET_FAILED(state, { message }) {
    store.dispatch('message/error', message || 'CUSTOMER_SMS_LIMIT.resetFailure')
  },
  ...generateFormHandlerMutations(state),
}

const modules = {
}

const watchers = [
  [state => state.customer.filters, _.debounce(async () => await store.dispatch('customer/fetchList'), 250), { immediate: false, deep: true }],
]

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
  watchers,
}
